<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="methodsVisible = !methodsVisible">
                 {{ $t('contract_reports.paving_methods') }}
              </h4>
          </div>
          <div
              v-if="reportsLoading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="methodsVisible = !methodsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:methodsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: methodsVisible }">
          <div class="col-12 border-bottom py-2">
              <table class="w-100" style="font-size: .9rem">
                  <tr v-for="(item, key) in methodReports" :key="key" class="nopads">
                      <td class="report-info">
                          <div>{{ item.name }}</div>
                      </td>
                      <td class="report-info">
                          <div>{{ item.totalAmount.toFixed(1) }} {{ item.unit }}</div>
                      </td>
                      <td class="report-info">
                          <div>{{ item.totalDistance ? Math.round(item.totalDistance) : 0 }} m</div>
                      </td>
                      <td class="report-info">
                          <div>{{ item.totalArea ? Math.round(item.totalArea) : 0 }} m2</div>
                      </td>
                      <td class="report-info">
                          <div>
                              {{ item.totalArea ? ((item.totalAmount * 1000) / item.totalArea).toFixed(2) : '-'  }} kg/m2
                          </div>
                      </td>
                  </tr>
              </table>
          </div>

          <div v-for="report in methodReports" :key="report.name" class="pb-2">
              <div style="font-size: 1.4em">
                  {{ report.name }}
              </div>
              <div style="font-weight: bold" class="pb-2">
                  {{ report.totalAmount.toFixed(2) }} {{ report.unit }}
              </div>
              <line-unload-record-table
                  v-if="report.lineUnloadRecords.length > 0"
                  :records="report.lineUnloadRecords"
              />
              <point-unload-record-table
                  v-if="report.pointUnloadRecords.length > 0"
                  :records="report.pointUnloadRecords"
              />
          </div>
    </div>
    <hr class="report-divider nopads">
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import LineUnloadRecordTable from "@/components/contractreport/LineUnloadRecordTable";
import PointUnloadRecordTable from "@/components/contractreport/PointUnloadRecordTable";
import BarChart from "@/components/chart/BarChart";

export default {
    name: "ContractReportPavingMethods",
    components: {BarChart, PointUnloadRecordTable, LineUnloadRecordTable},
    mixins: [timeUtils],
    props: {
        deliveryNotes: {
            type: Array,
            default() {
                return []
            }
        },
        reportsLoading: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            methodsVisible: false,
            methodReports: [],
            visible: false,
        }
    },
    watch: {
        deliveryNotes: function () {
            this.initData()
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            if (this.deliveryNotes.length > 0) {
                // Lanes
                this.deliveryNotes.forEach(item => {
                    if (item.line_unload_records.length > 0) {
                        item.line_unload_records.forEach(line => {
                            let methodReport = this.methodReports.find(report => report.name === line.unload_method)
                            if (methodReport) {
                                methodReport.totalAmount += line.amount ? line.amount : 0
                                methodReport.totalDistance += line.travel_distance ? line.travel_distance : 0
                                methodReport.totalArea += line.travel_distance && line.width ? line.travel_distance * line.width : 0
                                methodReport.lineUnloadRecords.push(line)
                            } else {
                                this.methodReports.push({
                                    name: line.unload_method,
                                    totalAmount: line.amount ? line.amount : 0,
                                    totalDistance: line.travel_distance ? line.travel_distance : 0,
                                    totalArea: line.travel_distance && line.width ? line.travel_distance * line.width : 0,
                                    unit: line.unit,
                                    lineUnloadRecords: [line],
                                    pointUnloadRecords: []
                                })
                            }
                        })
                    }
                })
                // Small areas
                this.deliveryNotes.forEach(item => {
                    if (item.point_unload_records.length > 0) {
                        item.point_unload_records.forEach(point => {
                            let methodReport = this.methodReports.find(report => report.name === this.$t('contract_reports.small_areas'))
                            if (methodReport) {
                                methodReport.totalAmount += point.amount ? point.amount : 0
                                methodReport.totalArea += point.area_size ? point.area_size : 0
                                methodReport.pointUnloadRecords.push(point)
                            } else {
                                this.methodReports.push({
                                    name: this.$t('contract_reports.small_areas'),
                                    totalAmount: point.amount ? point.amount : 0,
                                    unit: point.unit,
                                    totalArea: point.area_size ? point.area_size : 0,
                                    lineUnloadRecords: [],
                                    pointUnloadRecords: [point]
                                })
                            }
                        })
                    }
                })
            }
        }
    }
}
</script>

